import {getObject,postObjectWithApiError,IResultAndError} from '../../lib/ChoiceApi'; 
import {IRefundRegisterResponse,ITransactionUpdateRequest, ITransactionCreateRequest} from '../../lib/Models/RefundRegisterModel'; 
import {IBillingResponse} from '../../lib/Models/ClaimModel'; 

export enum ErrorReturnMessage {
    details = "Unable to obtain refund register details.",
    update = "Unable to update refund register.",
    cancel = "Unable to cancel refund register.",
    complete = "Unable to complete refund register.",
    create = "Unable to create refund register."
};
export async function getRefundRegister(registerIdentifier : string): Promise<IResultAndError<IRefundRegisterResponse>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/RefundRegister/GetRefundRegister/${registerIdentifier}`;
    const responseObject = await getObject<IRefundRegisterResponse>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.details;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}
export async function createRefundTransaction(payload: ITransactionCreateRequest): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/RefundRegister/CreateRefundTransaction", payload);
};
export async function updateRefundTransaction(payload: ITransactionUpdateRequest): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/RefundRegister/UpdateRefundTransaction", payload);
};
